<ag-shr-approve-deny-reasons-modal
  *ngIf="isEditable"
  #approveDenyReasonModalRef
  [title]="editModalOptions?.title ?? 'Agent Status Activity'"
  [isVisibilityTypeLocked]="editModalOptions?.isVisibilityTypeLocked"
></ag-shr-approve-deny-reasons-modal>

<ng-container *ngIf="gridState$ | async as gridState">
  <dx-data-grid
    #dataGridRef
    class="approve-deny-reasons-grid__data-grid"
    [ngClass]="{ 'approve-deny-reasons-grid__data-grid--view': !isEditable }"
    [dataSource]="gridState.dataSource"
    [syncLookupFilterValues]="false"
    [showRowLines]="true"
    [showBorders]="true"
    [showColumnLines]="true"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [rowAlternationEnabled]="false"
    (onRowRemoving)="onRowRemoving($event)"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before" [visible]="!!title">
        <div *dxTemplate>
          <div class="toolbar-label">
            <b>{{ title }}</b>
          </div>
        </div>
      </dxi-item>

      <dxi-item
        *ngFor="let toolbarItem of extraToolbarItems"
        [widget]="toolbarItem?.widget"
        [visible]="toolbarItem?.visible ?? true"
        [location]="toolbarItem?.location"
        [options]="toolbarItem?.options"
      >
      </dxi-item>

      <dxi-item
        *ngIf="canCreate && isEditable"
        location="after"
        widget="dxButton"
      >
        <div *dxTemplate>
          <dx-button
            icon="plus"
            [agMergeGuard]="agentDbIdValue"
            (agMergeGuardedClick)="showAddApproveDenyReasonPopup()"
          ></dx-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false">
    </dxo-editing>
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>
    <dxo-load-panel [enabled]="true"></dxo-load-panel>

    <dxi-column
      [width]="150"
      [dataField]="BaseModelKeys.createdByAgentDbId"
      [allowEditing]="false"
      caption="Created By"
      cellTemplate="createdByAgentDbIdCellTemplate"
    >
      <dxo-lookup [dataSource]="gridState.createdByLookup" valueExpr="value" displayExpr="description"></dxo-lookup>

      <div *dxTemplate="let cell of 'createdByAgentDbIdCellTemplate'">
        {{ cell?.data?.isSystem ? "System" : (cell.displayValue || cell?.data?.[BaseModelKeys.createdBy] || cell.value) }}
      </div>
    </dxi-column>

    <dxi-column
      [width]="150"
      [dataField]="BaseModelKeys.createdDate"
      [allowEditing]="false"
      [dataType]="'date'"
      [sortOrder]="'desc'"
      [format]="dateFormat"
      caption="Created Date"
    ></dxi-column>

    <dxi-column [width]="150" [dataField]="ApproveDenyReasonKeys.visibilityLevel">
      <dxo-lookup
        [dataSource]="approveDenyReasonVisibilityLevelLookup"
        valueExpr="value"
        displayExpr="description"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column [dataField]="ApproveDenyReasonKeys.activity"></dxi-column>

    <dxi-column [visible]="isEditable" cellTemplate="actionsTemplate" [width]="80"></dxi-column>
    <div *dxTemplate="let cell of 'actionsTemplate'" class="d-flex align-items-center">
      <dx-button
        *ngIf="getIsEditingAllowed({ row: { data: cell.data } }) && canEdit"
        icon="edit"
        stylingMode="text"
        [agMergeGuard]="agentDbIdValue"
        (agMergeGuardedClick)="showEditPopup({ row: { data: cell.data } })"
      ></dx-button>
      <dx-button
        *ngIf="getIsEditingAllowed({ row: { data: cell.data } }) && canDelete"
        icon="trash"
        stylingMode="text"
        (onClick)="dataGridRef.instance.deleteRow(cell.rowIndex)"
      ></dx-button>
    </div>
  </dx-data-grid>
</ng-container>
